
import { Loader } from '@googlemaps/js-api-loader';

const initRealtyMap = () => {
  const viewMap = document.querySelectorAll('.view-map');
  const target = document.querySelector('#list-results');
  const listContainer = document.querySelector('#initial-list');
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  const keywordRestBase = protocol + '//' + hostname + '/wp-json/list-by-keyword/v1';
  const keywordMapRestBase = protocol + '//' + hostname + '/wp-json/map-by-keyword/v1';
  const mapContainer = document.querySelector("#map-results");
  const propertyFilter = document.getElementById("property-filter");
  const propertyStatusFilter = document.getElementById('property-status-filter');
  const filterContainer = document.querySelector(".filter-list-container");
  const clearFiltersButton = document.getElementById("clear-filters");
  const url = new URL(window.location.href);
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let propertyType = urlParams.get('property');
  let propertyStatus = urlParams.get('status');

  if (mapContainer) {
    const GOOGLE_MAPS_API_KEY = window.project_map.maps_api_key ?? null;
    const GOOGLE_MAP_ID = window.project_map.map_id ?? null;

    if (viewMap) {
      viewMap.forEach((map) => {
        map.addEventListener('click', (e) => {
          const keyword = map.dataset.keyword;
          const keywordName = map.dataset.keywordname;
          listContainer.innerHTML = '';
          getListByKeyword(keyword, keywordName);
          
          url.searchParams.set("property", keyword);
          let newUrlString = [];
          newUrlString = url
            .toString();

          window.history.pushState(null, null, newUrlString);

          filterContainer.classList.remove('uk-flex-center');
          filterContainer.classList.remove('uk-text-center');

          const propertyFilterOptions = propertyFilter.options;
          for (let i = 0; i < propertyFilterOptions.length; i++) {
            if (propertyFilterOptions[i].value === keyword) {
              propertyFilter.selectedIndex = i;
              break;
            }
          }
        });
      });
    }

    if (propertyFilter) {
      propertyFilter.addEventListener('change', (e) => {
        const keyword = e.target.value;
        const keywordStatus = propertyStatusFilter.value;

        if (keyword) {
          const keywordName = e.target.options[e.target.selectedIndex].text;
          listContainer.innerHTML = '';
          getListByKeyword(keyword, keywordName, keywordStatus);
          
          url.searchParams.set("property", keyword);

          if (keywordStatus !== '') {
            url.searchParams.set("status", keywordStatus);
          }

          let newUrlString = [];
          newUrlString = url
            .toString();

          window.history.pushState(null, null, newUrlString);

          filterContainer.classList.remove('uk-flex-center');
          filterContainer.classList.remove('uk-text-center');
        } else {
          if (keywordStatus === '' && keyword === '') {
            resetList();
          } else {
            url.searchParams.delete("property");
            let newUrlString = [];
            newUrlString = url
              .toString();

            window.history.pushState(null, null, newUrlString);
            
            getListByKeyword('', '', keywordStatus);
          }
        }
      });
    }

    if (propertyStatusFilter) {
      propertyStatusFilter.addEventListener('change', (e) => {
        const keywordStatus = e.target.value;
        const keyword = propertyFilter.value;
        const keywordName = propertyFilter.options[propertyFilter.selectedIndex].text;

        if (keywordStatus) {
          listContainer.innerHTML = '';
          getListByKeyword(keyword, keywordName, keywordStatus);
          
          url.searchParams.set("status", keywordStatus);

          if (keyword !== '') {
            url.searchParams.set("property", keyword);
          }
          
          let newUrlString = [];
          newUrlString = url
            .toString();

          window.history.pushState(null, null, newUrlString);

          filterContainer.classList.remove('uk-flex-center');
          filterContainer.classList.remove('uk-text-center');
        } else {
          if (keywordStatus === '' && keyword === '') {
            resetList();
          } else {
            url.searchParams.delete("status");
            let newUrlString = [];
            newUrlString = url
              .toString();

            window.history.pushState(null, null, newUrlString);
            
            getListByKeyword(keyword, keywordName, '');
          }
        }
      });
    }

    const getListByKeyword = (keyword, keywordName, keywordStatus) => {
      const data = {
        'action' : 'list_by_keyword_rest',
        keyword: keyword,
        keywordName: keywordName,
        keywordStatus: keywordStatus
      }
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-WP-Nonce': list_by_keyword_rest.apiNonce,
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          data: data
        }),
      };

      fetch(keywordRestBase + '/search', options)
        .then((response) => {
          if (!response.ok) {
            const statusError = 'Error getting Search from API';
            
            if (response.status === 403) {
              console.log('Nonce Error');
            }
            throw new Error(statusError);
          } else {
            return response.json();
          }
        })
        .then((response) => {
          if (response.posts.length === 0) {
            target.innerHTML = '';
          } else {
            getMapByKeyword(keyword, keywordStatus);
            target.innerHTML = response.posts;
            clearFiltersButton.classList.remove('uk-hidden');
          }
        })
        .catch((response) => {
          console.log(response);
        });
    }

    const getMapByKeyword = (keyword, keywordStatus) => {
      const data = {
        'action' : 'map_by_keyword_rest',
        keyword: keyword,
        keywordStatus: keywordStatus
      }
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-WP-Nonce': map_by_keyword_rest.apiNonce,
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          data: data
        }),
      };

      fetch(keywordMapRestBase + '/search', options)
        .then((response) => {
          if (!response.ok) {
            const statusError = 'Error getting Search from API';
            
            if (response.status === 403) {
              console.log('Nonce Error');
            }
            throw new Error(statusError);
          } else {
            return response.json();
          }
        })
        .then((response) => {
          if (response.locations.length === 0) {

          } else {
            const mapData = response.locations.map(location => {
              return {
                ID: location.id,
                center: {
                  lat: parseFloat(location.latitude),
                  lng: parseFloat(location.longitude)
                },
                ...location
              }
            });
            loadMapResults(mapData, 6);
          }
        })
        .catch((response) => {
          console.log(response);
        });
    }

    // LOAD MAP WITH FILTERED LOCATIONS
    const loadMapResults = (mapResults, distance) => {
      
      const loader = new Loader({
        apiKey: GOOGLE_MAPS_API_KEY,
        version: "weekly",
      });

      // Promise for a specific library
      loader
      .importLibrary('maps')
      .then(async ({Map}) => {
        // ADD MAP ID TO .ENV
        const mapOptions = {
          mapId: GOOGLE_MAP_ID,
          center: mapResults[0].center,
          zoom: 6,
        };

        mapContainer.classList.add('active');
        
        const map = new Map(mapContainer, mapOptions);
        const { InfoWindow } = await loader.importLibrary('maps');
        const {AdvancedMarkerElement, PinElement} = await loader.importLibrary('marker');

        const infoWindow = new InfoWindow();
        mapResults.forEach(function(result){
          const position = sanitizePosition(result.center);
          if (!position) {
            console.error(`skipped plotting ${result.title} on map due to invalid longitude or latitude.`);
            return;
          }
          const markerColor = new PinElement({
            background: "#AB2133",
            borderColor: "#AB2133",
            glyphColor: 'white',
          });
    
          const marker = new AdvancedMarkerElement({
            map, 
            position,
            content: markerColor.element,
          });

          marker.addListener('click', e => {
            infoWindow.close();
            infoWindow.setContent(buildInfoWindow(result));
            infoWindow.open(map, marker);
          });
        });
      })
      .catch((e) => {
        console.error(e);
      });

      setTimeout(function(){
        target.style.display = 'block';
      }, 200);
    }

    const buildInfoWindow = location => {
      return `
        <div class="info-window-location">
          ${location.image}
          <h2><strong>${location.title}</strong></h2>
          <p class="info-window-location__address">${location.address}</p>
          <a href="/${location.slug}" class="info-window-location__link btn btn-primary">View Project</a>
        </div>
      `
    }

    const sanitizePosition = (position) => {
      if (position) {
        const { lat, lng } = position;
        let stringLat = lat.toString().trim();
        let stringLng = lng.toString().trim();

        // if stringLat has an emdash or endash, replace with minus symbol
        if (stringLat.includes('–') || stringLat.includes('—')) {
          stringLat = stringLat.replace('–', '-').replace('—', '-');
        }

        if (stringLng.includes('–') || stringLng.includes('—')) {
          stringLng = stringLat.replace('–', '-').replace('—', '-');
        }
        
        const floatLat = parseFloat(stringLat);
        const floatLng = parseFloat(stringLng);

        if (isNaN(floatLat) || isNaN(floatLng)) {
          console.error(`invalid position:`);
          console.log(position);
          return null;
        }

        position = {
          lat: floatLat,
          lng: floatLng
        }

      } else {
        console.error(`invalid position:`);
        console.log(position);
      }
      return position;
    }

    const resetList = () => {
      url.searchParams.delete("property");
      url.searchParams.delete("status");
      let newUrlString = [];
      newUrlString = url
        .toString();

      window.history.pushState(null, null, newUrlString);
      window.location.reload();
    }

    if (propertyType && !propertyStatus) {
      const propertyFilterOptions = propertyFilter.options;
      for (let i = 0; i < propertyFilterOptions.length; i++) {
        if (propertyFilterOptions[i].value === propertyType) {
          propertyFilter.selectedIndex = i;
          break;
        }
      }
  
      const keywordName = propertyFilter.options[propertyFilter.selectedIndex].text;
      
      listContainer.innerHTML = '';
      getListByKeyword(propertyType, keywordName);

      filterContainer.classList.remove('uk-flex-center');
      filterContainer.classList.remove('uk-text-center');
    }

    if (propertyStatus && !propertyType) {
      const propertyStatusFilterOptions = propertyStatusFilter.options;
      for (let i = 0; i < propertyStatusFilterOptions.length; i++) {
        if (propertyStatusFilterOptions[i].value === propertyStatus) {
          propertyStatusFilter.selectedIndex = i;
          break;
        }
      }

      const keywordName = propertyStatusFilter.options[propertyStatusFilter.selectedIndex].text;
      
      listContainer.innerHTML = '';
      getListByKeyword(propertyStatus, keywordName);

      filterContainer.classList.remove('uk-flex-center');
      filterContainer.classList.remove('uk-text-center');
    }

    if (propertyType && propertyStatus) {
      const propertyFilterOptions = propertyFilter.options;
      for (let i = 0; i < propertyFilterOptions.length; i++) {
        if (propertyFilterOptions[i].value === propertyType) {
          propertyFilter.selectedIndex = i;
          break;
        }
      }

      const propertyStatusFilterOptions = propertyStatusFilter.options;
      for (let i = 0; i < propertyStatusFilterOptions.length; i++) {
        if (propertyStatusFilterOptions[i].value === propertyStatus) {
          propertyStatusFilter.selectedIndex = i;
          break;
        }
      }

      const keywordName = propertyFilter.options[propertyFilter.selectedIndex].text;
      
      listContainer.innerHTML = '';
      getListByKeyword(propertyType, keywordName, propertyStatus);

      filterContainer.classList.remove('uk-flex-center');
      filterContainer.classList.remove('uk-text-center');
    }

    clearFiltersButton.addEventListener('click', (e) => {
      e.preventDefault();
      resetList();
    });
  }
};

export default initRealtyMap;
